(function () {
  if (window.__verticalThumbnailSliderInit) return;
  window.__verticalThumbnailSliderInit = true;

  function initGallery(track) {
    if (track.dataset.verticalSliderBound) return;
    track.dataset.verticalSliderBound = 'true';

    var gallery = track.closest('.product-gallery');
    if (!gallery) return;

    var upBtn = gallery.querySelector('[data-thumbnail-nav="up"]');
    var downBtn = gallery.querySelector('[data-thumbnail-nav="down"]');
    if (!upBtn && !downBtn) return;

    function updateNavState() {
      var hasOverflow = track.scrollHeight > track.clientHeight + 1;
      var maxScroll = track.scrollHeight - track.clientHeight;

      if (upBtn) {
        upBtn.classList.toggle('is-hidden', !hasOverflow);
        upBtn.classList.toggle('is-disabled', track.scrollTop <= 0);
      }
      if (downBtn) {
        downBtn.classList.toggle('is-hidden', !hasOverflow);
        downBtn.classList.toggle('is-disabled', track.scrollTop >= maxScroll - 1);
      }
    }

    function scrollThumbnails(direction) {
      var items = track.querySelectorAll('[data-gallery-thumbnail]');
      var step = track.clientHeight * 0.8;

      if (items.length > 1) {
        step = items[1].offsetTop - items[0].offsetTop;
      } else if (items.length === 1) {
        step = items[0].offsetHeight;
      }

      var maxScroll = track.scrollHeight - track.clientHeight;
      var target = Math.min(Math.max(track.scrollTop + step * direction, 0), maxScroll);
      track.scrollTo({ top: target, behavior: 'smooth' });
    }

    if (upBtn) {
      upBtn.addEventListener('click', function () {
        scrollThumbnails(-1);
      });
    }
    if (downBtn) {
      downBtn.addEventListener('click', function () {
        scrollThumbnails(1);
      });
    }

    track.addEventListener('scroll', updateNavState);
    window.addEventListener('resize', updateNavState);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateNavState).observe(track);
    } else {
      window.addEventListener('load', updateNavState);
    }
    updateNavState();

    var mainGallery = gallery.querySelector('[data-main-gallery]');
    var thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');

    if (mainGallery && thumbnails.length) {
      var slides = mainGallery.querySelectorAll('[data-product-gallery-slide]');

      var syncSelected = function () {
        var selectedIndex = -1;
        slides.forEach(function (slide, index) {
          if (slide.classList.contains('is-selected')) selectedIndex = index;
        });
        if (selectedIndex === -1) return;

        thumbnails.forEach(function (thumb, index) {
          thumb.classList.toggle('is-nav-selected', index === selectedIndex);
        });

        var activeThumb = thumbnails[selectedIndex];
        if (activeThumb) {
          activeThumb.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        }
      };

      var slideObserver = new MutationObserver(syncSelected);
      slides.forEach(function (slide) {
        slideObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-thumbnail-track]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
